import { revisions as _revisions } from "../../standardAttachables.js";
import { reviseSafetyObjectiveRegister } from "./actions.js";

export const objRevisions = {
    ..._revisions,
    "headers": [_revisions.headers[0], _revisions.headers[1]],
    "actions": [{
        "label": "Revise Safety Objective Register",
        "action": reviseSafetyObjectiveRegister
    }],
    "rowActions": [{
        "label": "Download",
        async action({ pageItem, rowItem, db }) {
            let url = await db.download(`Database/SafetyObjectiveRegister/${pageItem.ID}/Revisions/${rowItem.ID}/${rowItem.File}`);
            window.open(url, "fileView", "popup");
        }
    }]
};

export default [objRevisions];
